/* global window */
import React from 'react';
import {
  CarFilled,
  HistoryOutlined,
  ShoppingCartOutlined
} from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Cookies } from 'react-cookie';
import { getSidebarCollapsed, getUser } from 'src/redux/selectors';
import { collapseSidebar } from 'src/redux/actions/status';
import { findAllSites } from 'src/redux/actions/sites';
import {
  SITE_SIDEBAR_TABS,
  resolveSiteSidebarTabs
} from 'src/constants/sidebarTabs';
import {
  LayoutFilled,
  HomeFilled,
  RobotFilled,
  SignalFilled,
  NotificationFilled,
  CalendarFilled,
  LikeFilled,
  CheckSquareFilled
} from '@ant-design/icons';

const { Sider } = Layout;

const StyledLink = styled(Link)`
  color: #fff;
  :hover {
    text-decoration: none !important;
  }
  .anticon {
    color: #ec8144;
  }
`;

// Icon per tab, kept out of the shared constants file so that stays free of
// component imports.
const TAB_ICONS = {
  dashboard: LayoutFilled,
  sitemanagement: HomeFilled,
  users: RobotFilled,
  stock: SignalFilled,
  specialmanagement: NotificationFilled,
  tailoringmanagement: CalendarFilled,
  experiencemanagement: LikeFilled,
  checklists: CheckSquareFilled
};

const Sidebar = props => {
  const { user, sites, findAllSites } = props;

  // Sites are normally fetched by whichever page mounts, but on a fresh login
  // the sidebar can render first. Pull them in so the menu doesn't sit on the
  // fallback set longer than necessary.
  React.useEffect(() => {
    if (!sites || !sites.length) {
      Promise.resolve(findAllSites()).catch(() => {
        // Non-fatal: resolveSiteSidebarTabs falls back to the full set.
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const allowedTabs = resolveSiteSidebarTabs(user, sites);
  const visibleTabs = SITE_SIDEBAR_TABS.filter(tab =>
    allowedTabs.includes(tab.key)
  );

  const signOut = () => {
    if (window.cordova) {
      window.FirebasePlugin.getToken(
        token => {
          window.pubnub.push.deleteDevice(
            {
              device: token,
              pushGateway: 'gcm' // apns, gcm, mpns
            },
            function(status) {
              if (status.error) {
                console.log('operation failed w/ error:', status);
              }
            }
          );
        },
        error => {
          console.error(error);
        }
      );
    }

    const cookies = new Cookies();
    cookies.remove('token');
    cookies.remove('basic');
    localStorage.clear();
    window.location.reload();
  };

  return (
    <Sider
      width="72"
      collapsedWidth="80"
      trigger={null}
      collapsible
      collapsed={false}
      id="managerSidebarId"
      // width={170}
      style={{
        border: '1px solid #EC81443b',
        zIndex: 9,
        position: 'fixed',
        background: 'white',
        height: 'calc(100vh - 60px)',
        left: 0,
        top: 60,
        borderRight: ' 0.5px solid rgba(122, 122, 122, 0.39) '
      }}
    >
      <Menu
        style={{ background: 'none' }}
        theme="light"
        mode="inline"
        defaultSelectedKeys={['auctionstock']}
      >
        {/*     <Menu.Item
          style={{ marginTop: '15px' }}
          key="dashboard" 
        >
         <StyledLink to="/manager/dashboard">
            <Icon type="appstore" theme="filled" style={{ fontSize: '25px', paddingRight: '15px' }} />
            <span>Dashboard</span>
          </StyledLink>
        </Menu.Item>*/}
        {/* Previously three /manager/* links (Stock on Auction, My Basket,
            History) from the old auction product. None of those routes exist
            in routes.js any more, so every one of them rendered a blank page.
            Replaced with the same company-configurable tabs the buyer sidebar
            uses. */}
        {visibleTabs.map((tab, index) => {
          const Icon = TAB_ICONS[tab.key] || NotificationFilled;
          return (
            <Menu.Item
              key={tab.key}
              disabled={props.user.approved === true ? false : true}
              style={index === 0 ? { marginTop: '15px' } : undefined}
            >
              <StyledLink to={tab.path}>
                <Icon style={{ fontSize: '20px', paddingRight: '12px' }} />
                <span style={{ fontSize: '15px' }}>{tab.label}</span>
              </StyledLink>
            </Menu.Item>
          );
        })}

        {/*    <Menu.Item style={{ position: 'absolute', bottom: 110 }} key="account">
          <StyledLink to="/manager/account">
            <Icon type="setting" theme="filled" />
            <span>Account Settings</span>
          </StyledLink>
        </Menu.Item>
        <Menu.Item
          style={{ position: 'absolute', bottom: 70 }}
          onClick={signOut}
          key="signout"
        >
          {/* <StyledLink to="/"> 
          <Icon type="poweroff" />
          <span>Sign Out</span>
          {/* </StyledLink>
        </Menu.Item> */}
      </Menu>
    </Sider>
  );
};

const mapStateToProps = state => {
  return {
    collapsed: getSidebarCollapsed(state),
    user: getUser(state) || {},
    sites: state.sites.allSites || []
  };
};

const mapDispatchToProps = {
  collapseSidebar,
  findAllSites
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Sidebar)
);
